<template>
	<div class="appfooder">
		<div class="w">
			<div class="about_us" @click="go">Click to see super factory</div>
			<div style="text-align: center;line-height: 1.8;">
		    <p>{{ new Date().getFullYear() }} &copy; SKATESCUSTOM <a href="http://beian.miit.gov.cn/" target="_blank">冀ICP备09050278号-5</a>
			<br><img src="@/assets/1.png" class="pc-element" style="display:inline-block"></p>
			</div>
		    <div class="share">
		    	
				<share :config="config"></share>
				<a class="instagram" target="_blank" href="https://www.instagram.com/skatescustom_linda/">
				</a>

		    </div>
		</div>
	</div>
</template>

<script>

    
	export default {
		data () {
			return {
				config:{
		          sites: ['facebook','twitter'],
		        },
				vshareConfig:{
					shareList: [
			           "fbook",
			           "twi"
			        ],
				}
			}
		},
		components:{
          
		},
		computed: {
		},
		methods: {

			go(){
				this.$router.push("/about")
			}
		}
	}
</script>

<style lang="less">

    .appfooder{
	    .share{
	    	display:flex;
	    	align-items:center;
	    }
	}

	.share-component a{
		float: left;
		font-size: 18px;
		padding-left: 25px;
		line-height: 24px;
		height: 24px;
		background-repeat: no-repeat;
		cursor: pointer;
		margin: 6px 6px 6px 0;
	}

    .instagram{
    	margin-left:14px;
    	width:25px;
    	height:25px;
    	background-size:cover;
    	display:inline-block;
    	background-image:url("../assets/instagram.png") !important;
    }
	.icon-twitter{
		background-position:center !important;
		margin-right:0px !important;
		background-size:cover;
		background-image:url("../assets/twitter.png") !important;
	}
    .icon-facebook{
    	background-position:center !important;
    	margin-right:14px !important;
    	background-image:url("../assets/footer_FACEBOOK.png") !important;
    	background-size:cover;
    }
    .appfooder{
		 padding: 30px 0;
		 background-color: #000;
		 color: rgba(255,255,255,.5);
		 font-size: 14px;
		 .w{
		 	display: flex;
		 	align-items:center;
		    justify-content: space-between;
		 	margin:0 auto;
		 	width:94%;
		 	.about_us{
		 		font-size:18px;
		 		cursor: pointer;
		 	}
		 }
	}

	@media screen and (max-width:768px) {
		.appfooder{
		 	 min-width: 100%;
		 	 padding:10px 0;
			 height: auto;
			 display: block;
			 font-size: 12px;
			 .w{
			 	display:block;
			 	flex-wrap:wrap;
			 	padding: 0 4%;
			 	box-sizing: border-box;
			 	.about_us{
		 		   font-size:12px;
		 		   text-align:center;
		 	    }
			 }
			 .share{
			 	justify-content:center;
			 }
		}
    }
</style>



// WEBPACK FOOTER //
// src/components/appFooder.vue